export const performCheck = (value1: string | number, value2: string | number, operator: "=" | ">" | "<" | "!=") : boolean => {
    switch (operator) {
        case "=":
            return value1 === value2;
        case ">":
            return value1 > value2;
        case "<":
            return value1 < value2;
        case "!=":
            return value1 !== value2;
        default:
            return false;
    }
}

// Selected filter values and fetched lookup option values can represent the same logical
// value while differing by type, casing, or surrounding whitespace. Compare them loosely so
// the dropdown still marks the correct items as selected after reloading options.
export const matchesOptionValue = (selectedValue: string | number, optionValue: string | number): boolean => {
    if (selectedValue == optionValue) {
        return true;
    }
    else if (selectedValue === undefined || selectedValue === null || optionValue === undefined || optionValue === null) {
        return false;
    }

    return `${selectedValue}`.trim().toLowerCase() === `${optionValue}`.trim().toLowerCase();
};